import React, { Fragment } from 'react';
import { Formik, Field, Form } from 'formik';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import FormButtons from 'buyside/components/presentation/Form/FormButtons/formButtons';
import { validationSchema } from '../InviteNewMembersHelpers';

const {
  maxRewardTokenCount,
  refereeRegisteredRuleDurationIncrement,
  refereePublishedRuleDurationIncrement
} = require('buyside/util/constantsFromRails.json');

const InviteNewMembersForm = ({ handleSubmit, isRetail }) => {
  return (
    <Formik
      initialValues={{ emails: '', personalMessage: '' }}
      onSubmit={(values, actions) => handleSubmit(values, actions)}
      validationSchema={validationSchema}
      render={({ dirty, errors, handleReset, isSubmitting }) => {
        const hasErrors = !isSubmitting && !!Object.keys(errors).length;
        return (
          <Fragment>
            <p>
              SumZero grows through referrals from existing members. We strongly encourage you to
              invite colleagues and friends at other buyside shops to SumZero.
            </p>
            {isRetail ? (
              <p>
                When your referral signs up to SumZero, you will earn an idea credit (up to{' '}
                {maxRewardTokenCount} credits). Your invitee will also receive an extra credit.
              </p>
            ) : (
              <>
                <p>
                  If your referrals are accepted to SumZero, you may be eligible to{' '}
                  <strong>earn free access</strong> in the form of:
                </p>
                <ul>
                  <li>
                    <strong>{refereeRegisteredRuleDurationIncrement}</strong> when your referral
                    registers for and is accepted to SumZero.
                  </li>

                  <li>
                    <strong>{refereePublishedRuleDurationIncrement} of free access for you</strong>
                    when your referral posts their first idea and it is accepted.
                  </li>

                  <li>
                    <strong>{refereePublishedRuleDurationIncrement} of free access</strong>
                    when your referral posts their second idea.
                  </li>
                </ul>
              </>
            )}
            <Form>
              <Field
                component={InputField}
                label="Emails"
                name="emails"
                note="Paste From a Spreadsheet, or separate emails with a comma or a new line"
                type="textarea"
              />
              <Field
                component={InputField}
                label="Add a personal message"
                name="personalMessage"
                type="textarea"
              />
              <FormButtons
                dirty={dirty}
                hasErrors={hasErrors}
                isSubmitting={isSubmitting} // isSubmitting is sent down as props from Formik
                onCancel={handleReset} // handleReset is sent down as props from Formik
              />
            </Form>
          </Fragment>
        );
      }}
    />
  );
};

export default InviteNewMembersForm;
